import i18n from "@/i18n";

export const defaultAttachmentString: string = `📎 ${i18n.global.t(
  "chat.attachment",
)}`;
